import { Base } from '@studiometa/js-toolkit';

/**
 * ScrollTop component
 */
export default class StickyForm extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'StickyForm',
    refs: ['color', 'size', 'image'],
    emits: ['sync-size', 'sync-color'],
  };

  screenHeight = 0;

  /**
   * mounted hook
   */
  mounted() {
    // @todo update height ref value?
    this.screenHeight = window.innerHeight;
  }

  /**
   * resized hook
   */
  resized() {
    this.screenHeight = window.innerHeight;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {number} y The current vertical scroll position.
   */
  scrolled({ y }) {
    this.$el.classList.toggle('opacity-0', y < this.screenHeight);
    this.$el.classList.toggle('translate-y-full', y < this.screenHeight);
    this.$el.classList.toggle('pointer-events-none', y < this.screenHeight);
  }

  /**
   * on Select Color Change
   */
  onColorChange() {
    this.$emit('sync-color', this.$refs.color.value);
  }

  /**
   * on Select Size Change
   */
  onSizeChange() {
    this.$emit('sync-size', this.$refs.size.value);
  }
}
